// extracted by mini-css-extract-plugin
export default {"wrapper":"Tag-wrapper-tqv","orange":"Tag-orange-UJU"};